// src/api/devis.js
import axios from "../axiosInstance";

export function canonizeDevisEtat(input) {
  const s = String(input || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "");
  if (["brouillon", "envoye", "accepte", "abandonne"].includes(s)) return s;
  if (s.includes("accept")) return "accepte";
  if (s.includes("abandon")) return "abandonne";
  if (s.includes("envoy")) return "envoye";
  return "brouillon";
}

export async function updateDevisEtat(id, newEtatOrLabel) {
  const etat = canonizeDevisEtat(newEtatOrLabel);
  try {
    const { data } = await axios.patch(`/devis/${id}/etat`, { etat });
    return data ?? true;
  } catch (e) {
    if (e?.response?.status === 409) return true; // déjà dans cet état -> OK
    throw e;
  }
}

export async function getDevis(id) {
  // adapte ici si ton backend utilise une autre route
  const { data } = await axios.get(`/devis/${id}`);
  return data;
}

export async function listDevis(params = {}) {
  const { data } = await axios.get("/devis", { params });
  return data;
}
